import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import { buttonsReset } from 'src/store/modules/buttons';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { initTrackingValues } from '../TemplateTracking/BasicFullImageTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

const initViewValues = {
  bgImage: {
    background:
      'https://image.inappmessage.com/sample/defaultGRAYLONGIMAGE.webp'
  },
  deeplink: { background: 'https://www.inappmessage.com/' },

  text: { title: 'iam Template E-Commerce', sub_title: 'LOGO' },
  fontSize: { title: 18, sub_title: 14 },
  fontWeight: { title: 600, sub_title: 600 },
  color: { title: '#fff', sub_title: '#999' },
  fontFamily: { title: 'Montserrat', sub_title: 'Montserrat' },
  textAlign: { title: 'center', sub_title: 'center' },

  btnText: { left_button: 'Dont ask again', right_button: 'Close' },
  btnFontSize: { left_button: 0.75, right_button: 0.75 },
  btnFontWeight: { left_button: 600, right_button: 600 },
  btnColor: { left_button: '#999999', right_button: '#000000' },
  btnBgColorR: { left_button: 0, right_button: 0 },
  btnBgColorG: { left_button: 0, right_button: 0 },
  btnBgColorB: { left_button: 0, right_button: 0 },
  btnBgColorA: { left_button: 0, right_button: 0 },
  btnFontFamily: { left_button: 'Montserrat', right_button: 'Montserrat' },
  btnAgain: {
    type: 'none',
    left_button: "don't show"
  }
};

const BasicFullImage: FC = () => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const btnFontLeftURL = getFontURL(btnFontFamily?.left_button);
  const btnFontRightURL = getFontURL(btnFontFamily?.right_button);

  // const btnFontLeftURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily.left_button}`;
  // const btnFontRightURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily.right_button}`;

  const plusImageUrl = 'https://i.ibb.co/qMpSJ4w/Group-20.png';
  const style = `
  @font-face {
    font-family: 'btnFontLeft';
    src: url(${btnFontLeftURL});
  }

  @font-face {
    font-family: 'btnFontRight';
    src: url(${btnFontRightURL});
  }
  .root_view {
    ${
      bgImage?.background || bgImage?.background !== ''
        ? `background-image: url(${bgImage?.background});`
        : `background: rgba(0, 0, 0, 0.8);`
    };
    width: 100%;
    height: 100%;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    

    .modal_wrapper {
      width: 100%;
      line-height: 1.15456rem;
      cursor: pointer;
      padding: 1rem;
      padding-top: 2rem;

      display: flex;
      flex-direction: column;
      text-align: center;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);

      color: #fff;
      font-size: 0.78513rem;
      font-weight: 400;
      font-family: Roboto;
    }

    .plus_btn button {
      width: 1.1rem;
      height: 1.1rem;
      
      background-image: url(${plusImageUrl});
      background-repeat: no-repeat;
      background-size: 1.1rem;
      background-position: center;

      font-size: 0;
      border: none;
      border-radius: 50%;
      background-color: transparent;
    }

    .bottom_btn {
      width: 100%;
      height: 4.5rem;
      padding: 1rem 2.25rem;
      padding-bottom: 1.5rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;

      position: absolute;
      bottom: 0;
      background-color: #fff;
    }
    .bottom_btn button {
      border: 0;
      letter-spacing: 0.0225rem;
    }
    .bottom_btn .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: left;
      font-size: ${btnFontSize?.left_button}rem;
      font-weight: ${btnFontWeight?.left_button};
      color: ${btnColor?.left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.left_button
        )
          ? btnFontFamily?.left_button
          : 'btnFontLeft'
      };

      background-color:rgba(${btnBgColorR?.left_button},${
    btnBgColorG?.left_button
  }, ${btnBgColorB?.left_button}, ${btnBgColorA?.left_button});
    }
    .bottom_btn .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      text-align: right;
      font-size: ${btnFontSize?.right_button}rem;
      font-weight: ${btnFontWeight?.right_button};
      color: ${btnColor?.right_button};

      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.right_button
        )
          ? btnFontFamily?.right_button
          : 'btnFontRight'
      };

      background-color:rgba(${btnBgColorR?.right_button},${
    btnBgColorG?.right_button
  }, ${btnBgColorB?.right_button}, ${btnBgColorA?.right_button});
    }
  }
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        {(!bgImage?.background || bgImage?.background === '') && (
          <div className="modal_wrapper">
            텍스트가 포함된
            <br />
            이미지 또는 배경 이미지를
            <br />
            추가하세요
            <div className="plus_btn">
              <button>plus</button>
            </div>
          </div>
        )}

        <div className="bottom_btn">
          <button className="style01">{btnText?.left_button}</button>
          <button className="style02">{btnText?.right_button}</button>
        </div>
      </div>
    </>
  );
};
export default BasicFullImage;
